module.exports = __webpack_public_path__ + "img/a.b75006b9.jpg";